import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  const navLinks = [{
    name: 'Inicio',
    path: '/'
  }, {
    name: 'Nosotros',
    path: '/nosotros'
  }, {
    name: 'Servicios',
    path: '/servicios'
  }, {
    name: 'Antes y Después',
    path: '/antes-y-despues'
  }, {
    name: 'Testimonios',
    path: '/testimonios'
  }, {
    name: 'Contacto',
    path: '/contacto'
  }];
  return <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-primary/95 backdrop-blur-md border-b border-gold' : 'bg-primary border-b border-transparent'}`} data-id="element-260">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-261">
        <div className="flex justify-between items-center h-24" data-id="element-262">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 sm:gap-3 flex-shrink-0" data-id="element-263">
            <img src="https://cdn.magicpatterns.com/uploads/suW15tD8wF6YJTQp7zP6qm/qwwqqwqwqwqwqw-removebg-preview.png" alt="Odontología Estética Logo" className="h-12 sm:h-16 lg:h-20 w-auto logo-invert" data-id="element-264" />
            <span className="text-white font-bold text-sm sm:text-base lg:text-lg tracking-wide hidden sm:block max-w-[120px] lg:max-w-none leading-tight" data-id="element-265">
              ODONTOLOGÍA ESTÉTICA
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-6 xl:space-x-8" data-id="element-266">
            {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-sm font-medium transition-colors ${location.pathname === link.path ? 'text-gold' : 'text-white hover:text-gold'}`} data-id="element-267">
                {link.name}
              </Link>)}
            <a href="https://wa.me/573015892967" target="_blank" rel="noopener noreferrer" className="bg-gold hover:bg-gold-hover text-primary font-semibold px-5 xl:px-6 py-2.5 rounded-lg transition-colors whitespace-nowrap" data-id="element-268">
              Agendar Cita
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden flex items-center" data-id="element-269">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-gold p-2" aria-label="Toggle menu" data-id="element-270">
              {isMobileMenuOpen ? <X size={28} data-id="element-271" /> : <Menu size={28} data-id="element-272" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && <div className="fixed inset-0 top-24 bg-primary z-40 flex flex-col items-center pt-10 px-4 h-[calc(100vh-96px)] overflow-y-auto pb-10" data-id="element-273">
          <div className="flex flex-col space-y-6 w-full max-w-sm text-center" data-id="element-274">
            {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-xl font-medium py-3 border-b border-border ${location.pathname === link.path ? 'text-gold' : 'text-white hover:text-gold'}`} data-id="element-275">
                {link.name}
              </Link>)}
            <a href="https://wa.me/573015892967" target="_blank" rel="noopener noreferrer" className="bg-gold text-primary font-bold text-lg px-6 py-4 rounded-lg mt-8 w-full" data-id="element-276">
              Agendar Cita
            </a>
          </div>
        </div>}
    </nav>;
}